"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@chakra-ui/core");
const NavbarMenu_1 = __importDefault(require("./NavbarMenu"));
const Navbar = ({ title, menuConfig }) => {
    return (react_1.default.createElement(core_1.Box, { pos: "fixed", as: "nav", top: "0", zIndex: 4, bg: "white", left: "0", right: "0", borderBottomWidth: "1px", width: "full", height: "4rem", shadow: "sm" },
        react_1.default.createElement(core_1.Flex, { size: "100%", px: "6", align: "center", justify: "space-between" },
            react_1.default.createElement(core_1.Flex, { align: "center", mr: 5 },
                react_1.default.createElement(core_1.Box, { as: "a", display: "block", "aria-label": title || 'Homepage' },
                    react_1.default.createElement(core_1.Text, { fontSize: "lg", color: "black" }, title))),
            react_1.default.createElement(core_1.Flex, { flex: { sm: '1', md: 'none' }, ml: 5, align: "center", color: "gray.500", justify: "flex-end" },
                react_1.default.createElement(NavbarMenu_1.default, { menuConfig: menuConfig })))));
};
exports.default = Navbar;
